import { property, State } from '@common/lit/store';
import { Purpose } from '@common/types/model';
import { DisplayMode } from '@src/config';

export class ComponentStateStore extends State {
  [key: string | symbol]: unknown;

  @property({ value: false }) disabled!: boolean;

  @property({ value: DisplayMode.view }) displayMode!: DisplayMode;

  @property({ value: undefined }) activePurpose!: Purpose;
}

export const store = new ComponentStateStore();
